import React, { Fragment } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import clsx from "clsx";

import { renderWithBreaks } from '@utils/translations';
import styles from "@components/cancellationPoliciesPage/timelines/timeline.module.scss";

const TimelineNonRefundable = () => {
  const intl = useIntl();

  return (
    <Fragment>
      <h1>
        {intl.formatMessage({ id: 'Non-refundable' })} -{' '}
        <em>{intl.formatMessage({ id: 'No refund' })}</em>
      </h1>
      <ul>{renderWithBreaks(intl.formatMessage({ id: 'Timeline Non-refundable text' }), 'li')}</ul>
      <div className={styles.timeline}>
        <div
          className={clsx(
            styles.timeline__amount,
            styles.timeline__amountRefundRed
          )}
          style={{ width: '100%' }}
        >
          <FormattedMessage id={'No refund'} />
          <span className={styles.timeline__numberDays}>
            <FormattedMessage id={'Up to'} />:{' '}
            <strong>
              <FormattedMessage id={'Contract start'} />
            </strong>
          </span>
        </div>
      </div>
    </Fragment>
  );
};

export default TimelineNonRefundable;
